import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthSessionService } from './services/auth-session.service';
import { API_ROOT } from './services/api-service';

const SESSION_EXPIRED_HEADER = 'X-Auth-Session-Expired';

export const authSessionInterceptor: HttpInterceptorFn = (request, next) => {
  const authSession = inject(AuthSessionService);
  const apiRoot = inject(API_ROOT);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        error.headers.get(SESSION_EXPIRED_HEADER) === 'true' &&
        request.url.startsWith(apiRoot)
      ) {
        authSession.logout();
      }

      return throwError(() => error);
    }),
  );
};
